"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRejectionReasons;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _utils = require("../../../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getRejectionReasons(_ref) {
  var output = _ref.output;
  var videoStatusName = (0, _lodash.default)(output, 'status.name');

  if (output && videoStatusName === 'EDITING') {
    return (0, _utils.getCurrentVersion)(output).clientRejectionReasons || [];
  }

  return null;
}